module.exports = __webpack_public_path__ + "img/ch69.def88655.jpg";